import { CSSProperties, FC, useRef } from "react";
import Colors from "~/constants/colors";
import Icon from "../Icon";

interface UploadMediaItemProps {
  isMultiple?: boolean;
  onChange?: (imageUrl: string) => void;
  onFileChange?: (files: File[]) => void;
  useContainer?: boolean;
  containerSetting?: CSSProperties;
}

const UploadMediaItem: FC<UploadMediaItemProps> = ({
  onChange,
  containerSetting,
  isMultiple,
  onFileChange,
}) => {
  const _inputRef = useRef<HTMLInputElement>(null);

  return (
    <div style={containerSetting}>
      <input
        multiple={isMultiple}
        className="hidden"
        type="file"
        accept="image/png,image/jpg,image/jpeg"
        ref={_inputRef}
        onChange={(e) => {
          if (isMultiple) {
            const files = e.target.files;
            if (files) {
              onFileChange?.(Array.from(files));
            }
          } else {
            const file = e.target.files?.[0];
            if (file) {
              const url = URL.createObjectURL(file);
              onChange?.(url);
            }
          }
          if (_inputRef.current) {
            _inputRef.current.value = "";
          }
        }}
      />
      <div
        className="w-full h-full flex items-center justify-center cursor-pointer"
        onClick={() => _inputRef.current?.click?.()}
      >
        <Icon name="gallery-add" color={Colors.GREY_700} />
      </div>
    </div>
  );
};

export default UploadMediaItem;
